// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"17806671","977":"75287e8e"}[chunkId] + ".chunk.js";
};